import React from 'react';
import { motion } from 'framer-motion';
import { isEmpty, kebabCase } from 'lodash';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Button from '../layouts/Button';
import BoxedContainer from '../layouts/BoxedContainer';

export default function SportsActivities({ data }) {
  const { title } = data;
  const list = data.dswSportsList ? data.dswSportsList : data.dswAcademyList;
  return (
    <section
      className="lg:pt-[175px] pt-[80px] lg:pb-[200px] pb-[80px] bg-bg-1
    lg:-mt-[80px] -mt-[20px]"
    >
      <BoxedContainer className="regular">
        <div className="flex flex-col lg:gap-y-[59px] gap-y-[25px]">
          {isEmpty(title) || (
            <motion.h3
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: 0.3 }}
              viewport={{ once: true }}
              className="text-black lg:text-[48px] text-[32px] leading-[1]
              font-roboto-condensed-bold uppercase"
            >
              {title}
            </motion.h3>
          )}
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: 0.5 }}
            viewport={{ once: true }}
            className="flex flex-wrap gap-x-[30px] sm:gap-y-[30px] gap-y-[20px] sports-activities"
          >
            {list.map((item, index) => (
              <div
                key={index}
                className="bg-white flex flex-col 2xl:gap-y-[50px] sm:gap-y-[35px] gap-y-[20px]
                2xl:min-h-[537px] sm:min-h-[515px] min-h-[425px] lg:w-[calc(34.1%-30px)]
                sm:w-[calc(50%-15px)] w-full 2xl:pt-[48px] pt-[35px] 2xl:px-[40px] px-[20px]
                2xl:pb-[52px] pb-[45px] sports-card"
              >
                <div className="flex flex-row justify-between gap-x-5">
                  <div className="w-auto">
                    {item.icon && (
                      <LazyLoadImage
                        src={item.icon.url}
                        alt={item.title}
                        className="w-auto !h-[80px] object-contain"
                      />
                    )}
                  </div>
                  {item.sportIcon && (
                    <div className="w-auto">
                      <LazyLoadImage
                        src={item.sportIcon.url}
                        alt={item.title}
                        className="w-auto !h-[80px] object-contain"
                      />
                    </div>
                  )}
                </div>

                <div
                  className="flex flex-col justify-between 2xl:gap-y-[50px] sm:gap-y-[35px] h-full
                  gap-y-[20px]"
                >
                  <div className="flex flex-col 2xl:gap-y-8 sm:gap-y-5 gap-y-3">
                    <h4
                      className="sm:text-[23px] text-[23px] md:leading-[46px] leading-7 text-black
                    font-roboto-condensed-bold uppercase"
                    >
                      {item.title}
                    </h4>
                    <p
                      className="3xl:text-base text-[15px] sm:leading-[30px] leading-7 text-black
                      font-roboto-regular"
                    >
                      {item.description}
                    </p>
                  </div>
                  {isEmpty(item.url) || (
                    <Button
                      label="Learn More"
                      url={item.url}
                      ariaLabel={item.title}
                      tagName={kebabCase(data.contentTypeAlias)}
                      variant="primaryRed"
                      text="w-[130px] h-[45px]"
                    />
                  )}
                </div>
              </div>
            ))}
          </motion.div>
        </div>
      </BoxedContainer>
    </section>
  );
}
